module.exports = __webpack_public_path__ + "fonts/sf-medium.51fd7406.otf";